export default {
	label: 'Meede | Meetmed',
	type: 'Tüüp',
	status: 'Staatus | Staatused',
	addMeasure: 'Lisa meede',
	reference: 'Viide',
	category: {
		label: 'Kategooria | Kategooriad',
		error: {
			selectAtLeastOne: 'Vali vähemalt 1 kategooria',
		},
	},
	overrideType: 'Mooduli kaitsetarve ({module}) asendab meetme ({method}) oma',
	search: 'Otsi meedet',
	force: 'Sunnitud',
	serviceProvider: 'Teenusepakkuja',
	ruleComment: 'Reegli kommentaar',
	special: 'Eri',
	withComments: 'Kommentaaridega',
	withRuleComments: 'Reegli kommentaaridega',
	withoutComments: 'Ilma kommentaarideta',
	withoutRuleComments: 'Ilma reegli kommentaarideta',
	securityType: 'Turbeviis',
}
